import React from 'react';

import {
  FIELD_IDS,
  FIELD_NAMES,
  FIELD_TITLES,
  FIELD_TITLE_DESCRIPTIONS,
} from '@@vap-svc/constants';
import ProfileInformationFieldController from '@@vap-svc/components/ProfileInformationFieldController';

import { ProfileInfoSection } from '../../ProfileInfoSection';

const formatEmailTitle = title => title.replace('address', '').trim();

const generateRows = () => {
  return [
    {
      title: formatEmailTitle(FIELD_TITLES[FIELD_NAMES.EMAIL]),
      description: FIELD_TITLE_DESCRIPTIONS[FIELD_NAMES.EMAIL],
      id: FIELD_IDS[FIELD_NAMES.EMAIL],
      value: (
        <ProfileInformationFieldController fieldName={FIELD_NAMES.EMAIL} />
      ),
    },
  ];
};

const EmailInformationSection = () => {
  return (
    <ProfileInfoSection
      title="Email addresses"
      level={2}
      namedAnchor="email-address"
      data={generateRows()}
      className="vads-u-margin-bottom--6"
      enableAlertConfirmEmail
    />
  );
};

export default EmailInformationSection;
